/* TAPIS HOME CRO — navigation mobile non destructive; aucun achat automatique. */
(function () {
  function ready() {
    var bar = document.querySelector('[data-th-cro-mobile-action]');
    if (!bar) return;
    var target = document.querySelector('#MainContent variant-radios, #MainContent variant-selects, #MainContent .product-form__buttons');
    var buy = document.querySelector('#MainContent .product-form__submit');
    if (!target || !buy) return;
    var visible = true;
    var observer = new IntersectionObserver(function(entries) { visible = entries[0].isIntersecting; update(); }, { threshold: 0.1 });
    observer.observe(buy);
    function update() {
      bar.hidden = window.innerWidth >= 750 || visible || window.scrollY < 450;
    }
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
    bar.querySelector('[data-th-cro-scroll-to-options]').addEventListener('click', function() {
      target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center'});
    });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();